import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { SettingService } from '../services/settingService/setting.service';
import { AddFolderVM } from 'src/app/viewModels/core/add-folder-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-fillable-fields',
  templateUrl: './fillable-fields.component.html',
  styleUrls: ['./fillable-fields.component.scss']
})

export class FillableFieldsComponent implements OnInit {

  showSidePanel: boolean = false;
  showEditPanel:boolean = false;
  currentUser: any;
  addFolderForm: FormGroup;
  createFolderResponseHolder: any;
  getFolderVm = {
    userID: "",
    databaseID: 0,
    organizationID:0,
    OfficeIDList:[],
    officeID:0
  };
  getFolderListResponseHolder: any;
  folderList: any[] = [];
  folderCount: number;
  folderAccessCount: any[] = [];
  peopleTypeIndex: any;
  deleteResponseHolder: any;
  deleteModel={
    userID:"",
    databaseID:0,
    folderID:0,
    folderName:"",
    officeID:0,
    OfficeIDList:[]

  }

  folderAccess: any[] = [];
  getFieldsListResponseHolder: any;
  subscriptionPeopleList: any;
  permissionAsssign: any[] = [];
  folderListPermission : any[] = [];
  OfficeIDList: any[] = [];
  CompanyName:string="";
  CoreName:string="";
  ContactName:string="";
  menuModules: any[] = [];
  myOfficeID:any;
  
  constructor(private dialog: MatDialog, private formBuilder: FormBuilder,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router,
    private settingsService: SettingService, private addFolderVm: AddFolderVM,
    private commonService: CommonService) {
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.addFolderForm = this.formBuilder.group({
      folderName: ['', Validators.required]
    });

    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
  }

  ngOnInit(): void {
    this.menuModules = JSON.parse(sessionStorage.getItem("menuModules"));
    this.menuModules = this.menuModules.filter(x => x.folderID >0 && x.isAssign==true);   
    this.folderListPermission = this.menuModules;      
    this.folderListPermission= this.menuModules.filter(x => x.mainModuleName != 'Forms');
    this.folderCount = this.folderListPermission.length;
    this.commonService.setEditData(this.menuModules[0]);
    this.peopleTypeIndex = 0;
    this.folderListPermission.push({orgModuleName: "EDIT CUSTOM FIELDS",} );
  }  

  getcreateField(message: boolean) {
    this.showSidePanel = message;
  }
  
  closecreateField(message: boolean) {
    this.showSidePanel = message;
    //this.commonService.listRefreshPeople.next(true);
  }

  getopenEditSlide(message: boolean) {
    this.showEditPanel = message;
  }

  closeEditSlide(message: boolean) {
    this.showEditPanel = message;
    //this.commonService.listRefreshPeople.next(true);
  }

  openDialogWithRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }

  getFolderList() {
    this.getFolderVm.userID = this.currentUser.UID;
    this.getFolderVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getFolderVm.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.getFolderVm.officeID = this.myOfficeID;
    this.getFolderVm.OfficeIDList=this.OfficeIDList;    
    this.settingsService.getFolderList(this.getFolderVm).subscribe(response => {
      if (response != undefined) {
        this.getFolderListResponseHolder = response;
        if (this.getFolderListResponseHolder.status == this.statusConst.statusSuccess) {
          this.folderList = this.getFolderListResponseHolder.data;
          this.commonService.setEditData(this.folderList[0]);
          this.peopleTypeIndex = 0;
          this.folderList.push({folderName: "EDIT CUSTOM FIELDS",} )         
        }
        else {
          this.loaderService.hide();         
        }
      }
    });
  }

  createFolder(formValues) {
    if (formValues != undefined) {
      this.addFolderVm.userID = this.currentUser.UID;
      this.addFolderVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
      this.getFolderVm.organizationID = parseInt(sessionStorage.getItem('organizationID'));
      this.getFolderVm.officeID = this.myOfficeID;
      this.getFolderVm.OfficeIDList=this.OfficeIDList;    
      this.addFolderVm.folderName = formValues.folderName;
      this.loaderService.show();
      this.settingsService.createFolder(this.addFolderVm).subscribe(response => {
        if (response != undefined) {
          this.loaderService.hide();
          this.createFolderResponseHolder = response;
          if (this.createFolderResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success("Folder created successfully.", '', {
              timeOut: 3000,
            });
            this.close();
          }
          else {
            this.loaderService.hide();
            this.toastr.error(this.createFolderResponseHolder.message, '', {
              timeOut: 3000,
            });
            this.close();
          }
        }
      });
    }
  }

  ShowEditCustomFeild:boolean=false;
  
  getSubFolder(event) {
    this.peopleTypeIndex = event.index;
    this.commonService.setEditData(this.folderListPermission[event.index]);    
  }

  DeleteFolder(data) {
    const message = `Are you sure you want to delete this role?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });

    dialogRef.beforeClosed().subscribe(async dialogResult => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          this.deleteModel.userID = this.currentUser.UID;
          this.deleteModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
          this.deleteModel.folderID = data.folderID;
          this.deleteModel.officeID = this.myOfficeID;
          this.deleteModel.OfficeIDList=this.OfficeIDList;    
          this.deleteModel.folderName = data.folderName;
          const result = await this.settingsService.deleteFolder(this.deleteModel).toPromise();
          this.deleteResponseHolder = result;
          this.loaderService.hide();
          if (this.deleteResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success("Deleted successfully.", '', {
              timeOut: 3000,
            });
            this.getFolderList();
            return result;
          } else {
            this.toastr.error(this.deleteResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        } else {
          this.toastr.error(this.deleteResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  close() {
    this.dialog.closeAll();
  }

}
